const API_URL =
  import.meta.env.VITE_API_URL ??
  (import.meta.env.PROD
    ? "https://vektor-markets-api.vektor-api.workers.dev/api"
    : "/api");

let reporting = false;
export function reportClientError(error: unknown) {
  if (reporting) return;
  const normalized =
    error instanceof Error
      ? error
      : new Error(typeof error === "string" ? error : "Unknown client error");
  reporting = true;
  const token = sessionStorage.getItem("vektor-admin-token");
  void fetch(`${API_URL}/client-errors`, {
    method: "POST",
    credentials: "include",
    keepalive: true,
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    body: JSON.stringify({
      app: "admin",
      route: location.pathname.slice(0, 500),
      message: normalized.message.slice(0, 500),
      stack: normalized.stack?.slice(0, 4000) ?? null,
    }),
  })
    .catch(() => undefined)
    .finally(() => {
      reporting = false;
    });
}

export function installClientMonitoring() {
  window.addEventListener("error", (event) =>
    reportClientError(event.error ?? event.message),
  );
  window.addEventListener("unhandledrejection", (event) =>
    reportClientError(event.reason),
  );
}
